import { Table } from '@m/alchemy-ui';
import styled from 'styled-components';

export const StyledTable = styled(Table)`
  tbody tr:nth-child(odd) {
    background-color: #f7f7f7;
  }
  margin-bottom: 20px;
  width: 100%;
  table-layout: fixed;
`;
